<div *ngIf="element" class="survey-element surveys-element-button">
    <r-button
        [doNotExpand]="element.config?.doNotExpandWidth"
        [affirmative]="element.data?.affirmative"
        [negative]="element.data?.negative"
        [disabled]="disabled"
        [describedby]="element.id"
        [e2e]="'button-' + element.id"
        [elementId]="'button-' + element.id"
        [classes]="classes"
        (onClick)="execute()"
    >
        <div *ngIf="element.config?.prefixIconUrl" class="icon icon-prefix" [style.backgroundImage]="'url(' + element.config.prefixIconUrl + ')'"></div>
        {{ element.label[language] }}
        <div *ngIf="element.config?.suffixIconUrl" class="icon icon-suffix" [style.backgroundImage]="'url(' + element.config.suffixIconUrl + ')'"></div>
    </r-button>
</div>
